import React from 'react';
import './token-redemption-result.scss';
import SuccessIcon from 'assets/icons/success.svg';
import { SearchIcon } from 'assets/icons';
import { IconBtn } from '@ru-digital-assets/ui-component';
import currencyFormat from 'utils/currencyFormat';
import { useHistory } from 'react-router';
import { CopyIcon } from 'assets/icons';

interface ITokenRedemptionResult {
  asset: any;
}

export default function TokenRedemptionResult({
  asset,
}: ITokenRedemptionResult) {
  const history = useHistory();

  return (
    <div className="token-redemption-result">
      <img src={SuccessIcon} alt="Погашение успешно инициировано" />
      <p className="p p_font-size_32 p_font-weight_light mt_32 mb_32">
        Погашение успешно инициировано
      </p>
      <p className="p p_font-size_18 mb_32 text-center">
        Процедура погашения {asset.actualCount} токенов{' '}
        {asset.issuingInfo.tokenName} на сумму{' '}
        {currencyFormat(
          asset.actualCount * asset.issuingInfo.tokenPrice,
          true
        )}
        <br />
        Обладателя {asset.owner} успешно инициирована, ожидайте подтверждения
        Обладателя
      </p>
      <div className="flex align-center mb_32">
        <p className="p p_font-size_18 mr_10">
          ID транзакции:{' '}
          {asset.blockchainTransactionId.slice(0, 15) +
            '..' +
            asset.blockchainTransactionId.slice(-10)}
        </p>
        <CopyIcon
          className="cursor-pointer"
          width={20}
          height={20}
          onClick={() => {
            navigator.clipboard.writeText(asset.blockchainTransactionId);
          }}
        />
      </div>
      <div className="flex">
        <div className="mr_16">
          <IconBtn
            title="Посмотреть транзакцию в блокчейн Explorer"
            outlined
            icon={<SearchIcon />}
            onClick={() => {
              window!.open(`https://explorer.cfa.digital/tx/${asset.blockchainTransactionId}`, '_blank')!.focus();
            }}
          />
        </div>
        <IconBtn
          title="Перейти в активы"
          onClick={() => {
            history.push('/assets');
          }}
        />
      </div>
    </div>
  );
}
